import { Container } from '@gassan-ui'
import styled from 'styled-components'

export const Grid = styled(Container)``
Grid.defaultProps = {
  display: 'grid',
  mt: ['1.25rem', '2.5rem', '2.5rem', '2rem'],
  pb: 10,
  gridTemplateColumns: ['1fr 1fr', '1fr 1fr', '1fr 1fr', '1fr 1fr 1fr 1fr'],
  gridColumnGap: ['1rem', '1.5rem'],
  gridRowGap: ['2rem', '2.5rem', '2.5rem', '3rem'],
}
